import { useState } from 'react';
import { microwave } from '@round/api';
import { useAbortableEffect } from '@round/utils';
import { showNotification } from 'utility/showNotification';

type ContentTag = { id: number; name: string };

export function usePublicContentTags() {
    const [tags, setTags] = useState<ContentTag[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useAbortableEffect((signal) => {
        const fetchTags = async () => {
            try {
                setIsLoading(true);
                const response = await microwave.getPublicContentTags({ page: 1 }, { signal });
                setTags(response.data.results);
            } catch (error) {
                if (!signal.aborted) {
                    showNotification('Could not load tags', 'error');
                }
            } finally {
                if (!signal.aborted) {
                    setIsLoading(false);
                }
            }
        };

        fetchTags();
    }, []);

    return { tags, isLoading };
}
